import { defineStore } from 'pinia'
import { ref, computed } from "vue"

export const useAuthStore = defineStore( 'auth', () => {
  const token = ref( null )
  const user = ref( null )

  function setToken( data ) {
    token.value = data.access_token
    user.value = data.user
  }

  function clearToken() {
    token.value = null
    user.value = null
  }

  function updateUser( aUser ) {
    user.value = aUser
  }

  const isLoggedIn = computed( () => token.value !== null )
  const isAdmin = computed( () => user.value?.is_admin )

  return { token, user, setToken, clearToken, isLoggedIn, updateUser, isAdmin }
}, {
  persist: true
})